<template>
  <page-outline :title="$t('Webheader.injection_unit')">
    <template slot="pageContent">
      <div slot="pageContent">
        <b-container fluid>
          <form-accordion :toggleActive="false"  :title="$t('tracking.general_information')" :isTitleUpperCase="false">
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col sm="6" class="form-group">
                <span>{{ $t('tracking.please_enter_iban_to_verify') }}</span>
                <br>
                <br>
                <br>

                <form-write-group-label-input v-model="form.iban" isMandatory
                  :inputLabel="$t('tracking.iban') + ' ' + $t('tracking.to_check')"
                  :descLabel="$t('tracking.iban_description')"
                  :placeholderValue="$t('tracking.iban')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <br>
                <br>
                <br>
                <br>
                <form-write-group-label-input v-if="verifierIBAN(form.iban) && form.iban != '' && corporateIdentifierTypesMatch" v-model="form.reference"
                  :inputLabel="$t('tracking.reference')" :placeholderValue="$t('tracking.reference')">
                </form-write-group-label-input>
              </b-col>
<!--              <b-col sm="6" class="form-group">-->
<!--                <label>-->
<!--                  {{ $t('tracking.buisness_reference_type') }}<span class="color-red"> * </span>-->
<!--                </label>-->
<!--                <select class="form-control" v-model="form.businessReferenceType">-->
<!--                  <option value=""> {{ $t('tracking.select_buisness_reference') }} </option>-->
<!--                  <option value="RUM">{{ $t('tracking.select.RUM')}}</option>-->
<!--                  <option value="Other">{{ $t('tracking.select.Other')}}</option>-->
<!--                </select>-->
<!--              </b-col>-->
            </b-row>
          </form-accordion>
          <form-accordion v-if="ibanFind" :toggleActive="true"  :title="$t('tracking.information_retrieved_from_iban')" :isTitleUpperCase="false">
            <b-row class="d-flex justify-content-center align-items-start">
              <b-col sm="4" class="form-group">
                <div class="table-responsive">
                  <table style="height: 270px" class="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th colspan="2" class="text-light align-middle" style="background-color: #404040 !important;">{{ $t('tracking.valid_iban') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.iban_format_verification') }}</td>
                        <td class="align-middle"><i v-if="format == '$Match'" class="fa-solid fa-check text-success"></i><i v-else class="fa-solid fa-xmark text-danger"></i></td>
                      </tr>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.account_key_verification') }}</td>
                        <td class="align-middle"><i v-if="keyIban == '$Match'" class="fa-solid fa-check text-success"></i><i v-else class="fa-solid fa-xmark text-danger"></i></i></td>
                      </tr>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.iban_key_verification') }}</td>
                        <td class="align-middle"><i v-if="keyBBAN == '$Match'" class="fa-solid fa-check text-success"></i><i v-else class="fa-solid fa-xmark text-danger"></i></td>
                      </tr>
                      <tr>
                        <td class="align-middle">{{ $t('tracking.bank_reachable') }}</td>
                        <td class="align-middle"><i v-if="corporateIdentifierTypesMatch" class="fa-solid fa-check text-success"></i><i v-else class="fa-solid fa-xmark text-danger"></i></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <!-- <b-col sm="4" class="form-group">
                <table style="height: 270px" class="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th class="text-light" style="background-color: #404040 !important;">{{ $t('tracking.bank_domiciliation') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="col-md-12"><b id="InstitutionName">{{ institutionName === '$NotFound' ? '': institutionName }}</b></div>
                        <div class="col-md-12 mb-1" id="BranchInformation">{{ branchInformation === '$NotFound' ? '': branchInformation }}</div>
                        <div class="col-md-12 mb-1" id="StreetAddress1">{{ address1 === '$NotFound' ? '': address1 }}</div>
                        <div class="col-md-12 mb-1" id="StreetAddress2">{{ address2 === '$NotFound' ? '': address2 }}</div>
                        <div class="col-md-12 mb-1" id="StreetAddress3">{{ address3 === '$NotFound' ? '': address3 }}</div>
                        <div class="col-md-12 mb-1" id="StreetAddress4">{{ address4 === '$NotFound' ? '': address4 }}</div>
                        <div class="col-md-12 mb-1" id="ZipCodeCity"><span id="ZipCode">{{ zipCode === '$NotFound' ? '': zipCode }}</span><span>&nbsp;</span><span id="City">{{ city === '$NotFound' ? '': city }}</span></div>
                        <div class="col-md-12 mb-1" id="Cps">{{ Cps === '$NotFound' ? '': Cps }}</div>
                        <div class="col-md-12 mb-5" id="CountryNameAndIso"><span id="CountryName">{{ country === '$NotFound' ? '': country }}</span>&nbsp;<span v-if="ISOCountryCode !== '$NotFound'">(<span id="IsoCountryCode">{{ ISOCountryCode === '$NotFound' ? '': ISOCountryCode }}</span>)</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col> -->
              <b-col sm="4" class="form-group">
                <div class="table-responsive">
                  <table style="height: 270px" class="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th colspan="2" class="text-light align-middle" style="background-color: #404040 !important;">{{ $t('tracking.bank_domiciliation') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.institution_name') }}</td>
                        <td v-if="institutionName !== '' && institutionName !== '$NotFound'" class="align-middle" id="InstitutionName">{{ institutionName }}</td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.branch_information') }}</td>
                        <td v-if="branchInformation !== '' && branchInformation !== '$NotFound'" class="align-middle" id="BranchInformation">{{ branchInformation }}</td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.address_line_1') }}</td>
                        <td v-if="address1 !== '' && address1 !== '$NotFound'" class="align-middle" id="StreetAddress1">{{ address1 }}</td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr v-if="address2 !== '' && address2 !== '$NotFound'" style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.address_line_2') }}</td>
                        <td class="align-middle" id="StreetAddress2">{{ address2 }}</td>
                      </tr>
                      <tr v-if="address3 !== '' && address3 !== '$NotFound'" style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.address_line_3') }}</td>
                        <td class="align-middle" id="StreetAddress3">{{ address3 }}</td>
                      </tr>
                      <tr v-if="address4 !== '' && address4 !== '$NotFound'" style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.address_line_4') }}</td>
                        <td class="align-middle" id="StreetAddress4">{{ address4 }}</td>
                      </tr>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.zip_and_city') }}</td>
                        <td v-if="(zipCode !== '' && zipCode !== '$NotFound') || (city !== ''  && city !== '$NotFound')" class="align-middle" id="ZipCodeCity"><span id="ZipCode">{{ zipCode }}</span><span>&nbsp;</span><span id="City">{{ city }}</span></td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                      <tr v-if="Cps !== '' && Cps !== '$NotFound'" style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.cps') }}</td>
                        <td class="align-middle" id="Cps">{{ Cps }}</td>
                      </tr>
                      <tr style="background-color: #F9F9F9">
                        <td class="align-middle">{{ $t('tracking.country_and_iso') }}</td>
                        <td v-if="(country !== '' && country !== '$NotFound') || (ISOCountryCode !== '' && ISOCountryCode !== '$NotFound')" class="align-middle" id="CountryNameAndIso"><span id="CountryName">{{ country }}</span>&nbsp;<span v-if="ISOCountryCode !== '$NotFound'">(<span id="IsoCountryCode">{{ ISOCountryCode }}</span>)</span></td>
                        <td v-else class="align-middle">-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-col sm="4" class="form-group">
                <div class="table-responsive">
                  <table style="height: 270px" class="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th colspan="2" class="text-light align-middle" style="background-color: #404040 !important;">{{ $t('tracking.iban_composition') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr style="background-color: #F9F9F9">
                      <td class="align-middle">{{ $t('tracking.bank_code') }}</td>
                      <td class="align-middle">{{ IDBank === '$NotFound' ? '-': IDBank}}</td>
                    </tr>
                    <tr style="background-color: #F9F9F9">
                      <td class="align-middle">{{ $t('tracking.branch_code') }}</td>
                      <td class="align-middle">{{ IDBranch === '$NotFound' ? '-': IDBranch}}</td>
                    </tr>
                    <tr style="background-color: #F9F9F9">
                      <td class="align-middle">{{ $t('tracking.account_number') }}</td>
                      <td class="align-middle">{{ accountNumber === '$NotFound' ? '-': accountNumber}}</td>
                    </tr>
                    <tr>
                      <td class="align-middle">{{ $t('tracking.bic') }}</td>
                      <td class="align-middle">{{ parentBic === '$NotFound' ? '-': parentBic }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </form-accordion>
          <form-accordion :toggleActive="false" v-if="verifierIBAN(form.iban) && form.iban !== '' && corporateIdentifierTypesMatch" :title="$t('tracking.data_to_check')" :isTitleUpperCase="false">
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col sm="6" class="form-group">
                <label for="identifier-type">
                  {{ $t('tracking.type_identifier') }}<span class="color-red"> * </span>
                </label>
                <select id="identifier-type" class="form-control" v-model="form.entrepriseIdentifierType" :required="verifierIBAN(form.iban) && form.iban !== ''" :disabled="!verifierIBAN(form.iban) || form.iban === ''">
                  <option value=""> {{ $t('common.nme') }} </option>
                  <option v-for="type in Object.keys(this.typeList).filter(elem => !typeList[elem])" :key="type" :value="type">
                    {{ $t('tracking.select.identifiers.' + type + '.label')}}
                  </option>
                </select>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="form.entrepriseIdentifierName" isMandatory :disabled="!verifierIBAN(form.iban) || form.iban == ''"
                  :inputLabel="$t('tracking.identifier')" :placeholderValue="$t('tracking.identifier')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
              </b-col>
            </b-row>
          </form-accordion>

          <b-row class="accordionForm mt-3 justify-content-end">
            <b-col cols="4" lg="3" xl="2">
              <b-button variant="primary" class="responsive-button" @click="addTracking" :disabled="!validateForm(false) || activateSpinner">
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.send_verification_request') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from "@/components/common/PageOutline.vue";
import {loadPage} from "@/helpers/routing";
import {errorMessageAlert} from "@/helpers/alert";
import moment from "moment/moment";
import {downloadFileWithDefinedHeaders} from "@/helpers/download";
import conf from '../../config/config.dev.js'

export default {
  name: 'TrackingForm',
  components: {
    PageOutline,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      flagCACP: conf.visual != 'CACP' ? false : true,
      activateSpinner: false,
      ibanFind: false,
      corporateIdentifierTypesMatch: false,
      format: '',
      keyIban: '',
      keyBBAN: '',
      IDBank: '',
      IDBranch: '',
      accountNumber: '',
      ibanNationalID: '',
      nationnalID: '',
      BIC: '',
      institutionName: '',
      branchInformation: '',
      address1: '',
      address2: '',
      address3: '',
      address4: '',
      city: '',
      zipCode: '',
      Cps: '',
      country: '',
      ISOCountryCode: '',
      institutionParentName: '',
      parentBic: '',
      form: {
        name: '',
        iban: '',
        business: '',
        reference: '',
        businessReferenceType: '',
        entrepriseIdentifierName: '',
        entrepriseIdentifierType: ''
      },
      typeList: {
        BANK: true,
        CBID: true,
        CHID: true,
        CINC: true,
        COID: true,
        CUST: true,
        DUNS: true,
        EMPL: true,
        GS1G: true,
        SREN: true,
        SRET: true,
        TXID: true,
        BDID: true,
        BOID: true,
        LEIC: true,
        EUID: true,
        BICC: true,
      },
    }
  },
  watch: {
    'form.iban': function(newIban, oldIban) {
      if (newIban && this.verifierIBAN(newIban)) {
        this.controlIban(newIban)
      }
    }
  },
  created () {
  },
  methods: {
    controlIban (iban) {
      this.ibanFind = false
      this.corporateIdentifierTypesMatch = false
      if (iban) {
        let that = this
        this.$engine.tracking.getVerifIban({IBAN: iban.toUpperCase().replace(/\s+/g, '').trim()}
        ).then(resp => {

          that.ibanFind = true
          that.format = resp.data.format
          that.keyIban = resp.data.keyIban
          that.keyBBAN = resp.data.keyBBAN
          that.IDBank = resp.data.IDBank
          that.IDBranch = resp.data.IDBranch
          that.accountNumber = resp.data.accountNumber
          that.ibanNationalID = resp.data.ibanNationalID
          that.nationnalID = resp.data.nationnalID
          that.BIC = resp.data.BIC
          that.institutionName = resp.data.institutionName
          that.branchInformation = resp.data.branchInformation
          that.address1 = resp.data.address1
          that.address2 = resp.data.address2
          that.address3 = resp.data.address3
          that.address4 = resp.data.address4
          that.city = resp.data.city
          that.zipCode = resp.data.zipCode
          that.country = resp.data.country
          that.ISOCountryCode = resp.data.ISOCountryCode
          that.institutionParentName = resp.data.institutionParentName
          that.parentBic = resp.data.parentBic

          Object.keys(that.typeList).forEach(key => {
            that.typeList[key] = true
          })

          if (resp.data.bankReachable === 1) {
            that.corporateIdentifierTypesMatch = true
            resp.data.corporateIdentifierTypes.forEach(identifier => {
              if (that.typeList.hasOwnProperty(identifier.Name)) {
                that.typeList[identifier.Name] = false
              }
            })
          } else {
            let error = {response: {
                status: 404,
                data : {
                  error:'We couldn\'t locate a valid BIC',
                  errorDescription:'We couldn\'t find a valid BIC for the specified account or entity.'
                }
              }}
            errorMessageAlert(error, that)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    verifierIBAN (iban) {
      if (this.form.entrepriseIdentifierType !== '') {
        if (this.typeList[this.form.entrepriseIdentifierType] == true) {
          this.form.entrepriseIdentifierType = ''
        }
      }
      iban = iban.replace(/\s+/g, '').toUpperCase()

      const longueurIBAN = {
        AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
        CH: 21, CR: 22, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, FI: 18,
        FO: 18, FR: 27, GB: 22, GE: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21, HU: 28,
        IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LC: 32, LI: 21,
        LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30,
        NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, SA: 24,
        SC: 31, SE: 24, SI: 19, SK: 24, SM: 27, ST: 25, SV: 28, TL: 23, TN: 24, TR: 26,
        UA: 29, VA: 22, VG: 24, XK: 20
      }

      const codePays = iban.slice(0, 2)
      const longueurAttendue = longueurIBAN[codePays]

      if (!longueurAttendue || iban.length !== longueurAttendue) {
        return false
      }

      const ibanReforme = iban.slice(4) + iban.slice(0, 4)

      const ibanNumerique = ibanReforme.replace(/[A-Z]/g, char => char.charCodeAt(0) - 55)

      let reste = ''
      for (let i = 0; i < ibanNumerique.length; i += 7) {
        reste = String(parseInt(reste + ibanNumerique.slice(i, i + 7), 10) % 97)
      }

      return parseInt(reste, 10) === 1
    },
    addTracking () {
      if (this.validateForm()) {

        let form = {
          Reference: this.form.reference,
          BIC: this.BIC,
          IBAN: this.form.iban.trim()
        }

        if (this.form.entrepriseIdentifierType === '') {
          form.Name = this.form.entrepriseIdentifierName
        } else {
          form.EnterpriseType = this.form.entrepriseIdentifierType
          form.Identifier = this.form.entrepriseIdentifierName
        }

        this.activateSpinner = true
        this.$f7.showPreloader(this.$i18n.t('tracking.ddv_sending'))
        let that = this
        this.$engine.tracking.create(form)
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$t('tracking.ddv_sent'),
            text: '<i class="icon fa-solid fa-check text-success"></i>'
          })
          setTimeout(function () {
            that.activateSpinner = false
            that.$f7.closeModal()
            loadPage(that, { url: '/tracking/DDV/NULL' })
            // loadPage(that, { url: '/trackingdetails/DDV/' + resp.data.Reference })
          }, 3000)
        })
        .catch(e => {
          that.activateSpinner = false
          errorMessageAlert(e, that)
        })
      }
    },
    validateForm (alert = true) {
      if (!this.verifierIBAN(this.form.iban.trim()) || this.form.iban.trim() === '') {
        if (alert){
          this.$f7.alert(that.$i18n.t('errors.chng_the_iban_to_vld_frmt'), this.$i18n.t('errors.error_label'))
        }
        return false
      }

      if (this.form.entrepriseIdentifierName === '') {
        if (alert){
          this.$f7.alert(that.$i18n.t('errors.miss_id'), this.$i18n.t('errors.error_label'))
        }
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>

@media (max-width: 600px) {
  .responsive-button {
    min-height: 70px;
  }
}

@media (min-width: 605px) and (max-width: 2200px) {
  .responsive-button {
    min-height: 60px;
  }
}
</style>
